import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {
    Box,
    TextField,
    Select,
    MenuItem,
    FormControl,
    FormHelperText,
} from '@mui/material';
import * as C from '../../services/constants';
import { hideLoading, showLoading } from '../../store/actions/loadingActions';
import {
    notify,
    notifyError,
    notifySuccess,
} from '../../store/actions/notificationActions';
import {
    getWeight,
    createGoal,
    updateGoal,
    deleteGoal,
    getProducts,
    getWeightById,
} from '../../services/api/nbaApi';
import ConfirmDialog from './ConfirmDialog';

const goalTypeOptions = ['Cross sell', 'Up sell', 'Loyalty', 'Repeat Purchase'];

const GoalEditor = ({ onClose, goalId, status, type, origin }) => {
    const dispatch = useDispatch();
    const { auth } = useSelector((state) => state);
    const { market, category, brand } = auth.user;
    //console.log("GoalId:::::", goalId);
    const [id, setId] = useState(null);
    //const [productOptions, setProductOptions] = useState([]);
    const [goalType, setGoalType] = useState('');
    const [goalName, setGoalName] = useState('');
    const [weight, setWeight] = useState('');
    //const [product, setProduct] = useState('');
    const [createdAt, setCreatedAt] = useState('');
    const [updatedAt, setUpdatedAt] = useState('');
    const [weightInputBlocked, setWeightInputBlocked] = useState(false);
    const [saveEnabled, setSaveEnabled] = useState(false);
    const [touched, setTouched] = useState({
        goalType: false,
        goalName: false,
        weight: false,
        //product: false,
    });
    const [confirmDialog, setConfirmDialog] = useState({
        display: false,
        title: '',
        message: '',
        note: '',
        onClose: null,
        onConfirm: null,
        confirmText: '',
        backText: '',
    });

    const [existingGoals, setExistingGoals] = useState([]);

    const getValidationErrors = () => {
    const errors = {};

        if (touched.goalType && goalType.trim() === '') {
            errors.goalType = 'Goal type is required';
        }

    // Check for duplicate goal type
        if (touched.goalType && goalType.trim() !== '') {
            const duplicateGoal = existingGoals.find(
            goal => goal.goalType === goalType && goal.goalId !== goalId 
            && goal.goalStatus?.toLowerCase() === 'active'
         );
        if (duplicateGoal) {
            errors.goalType = 'This goal type already exists for this brand and market combination';
        }
    }

    if (touched.goalName) {
        if (goalName.trim() === '') {
            errors.goalName = 'Goal name is required';
        } else if (goalName.length > 200) {
            errors.goalName = 'Goal name cannot exceed 200 characters';
        }
    }
      // if (touched?.product && product?.trim() === '') {
        //     errors.product = 'Product family is required';
        // }


    if (touched.weight) {
        if (weight === '') {
            errors.weight = 'Weight is required';
        } else if (weightInputBlocked) {
            errors.weight = 'Please enter a decimal value starting with 0 or 1 or . (e.g., 0.5 or .5)';
        } else if (
            weight.length > 0 &&
            // weight !== '0' &&
            weight !== '1' &&
            !weight.startsWith('0.') &&
            !weight.startsWith('.')
        ) {
            errors.weight = 'Weight must be 1, or start with a decimal value (e.g. 1, 0.5 or .5)';
        } else if (!C.REGEX_GOAL_WEIGHT.test(weight)) {
            errors.weight = 'Weight must be a decimal with maximum 1 digit(0 or 1) before decimal and 2 digits after decimal (e.g., 0.23)';
        } else {
            const numValue = parseFloat(weight);
            if (isNaN(numValue) || numValue <= 0 || numValue > 1) {
                errors.weight = 'Weight must be greater than 0 and less than or equal to 1';
            } else {
                // Check total weight sum
                const currentWeight = parseFloat(weight);
                const otherGoalsWeight = existingGoals
                    .filter(goal => goal.goalId !== id
                         && goal.goalStatus?.toLowerCase() === 'active'
                        )
                    .reduce((sum, goal) => sum + parseFloat(goal.weight || 0), 0);
                
                if (currentWeight + otherGoalsWeight > 1) {
                    errors.weight = `Total weight cannot exceed 1. Current total would be ${(currentWeight + otherGoalsWeight).toFixed(2)}`;
                }
            }
         }
        }

        return errors;
    };

    // useEffect(() => {
    //     getProducts(market, brand)
    //         .then((response) => {
    //             // Fixed: Removed console.log and improved array creation
    //             // const formattedProducts =
    //             //     response?.data?.map((product) => ({
    //             //         id: product?.id,
    //             //         name: product?.name,
    //             //     })) || [];
    //             setProductOptions(response?.data);
    //         })
    //         .catch((error) => {
    //             dispatch(hideLoading());
    //         })
    //         .finally(() => dispatch(hideLoading()));
    // }, []);

    const validationErrors = getValidationErrors();

    const validateForm = () => {
    const errors = getValidationErrors();
    const hasErrors = Object.keys(errors).length > 0;
    
    const isGoalTypeValid = goalType.trim() !== '';
    const isGoalNameValid = goalName.trim() !== '' && goalName.length <= 200;
     //const isProductValid = product?.trim() !== '';
    const isWeightValid = weight !== '' && parseFloat(weight) > 0 && parseFloat(weight) <= 1;

    return isGoalTypeValid && isGoalNameValid && isWeightValid && !hasErrors
    //&& isProductValid
    ;
};

    useEffect(() => {
        setSaveEnabled(validateForm());
    }, [goalType, goalName, weight,existingGoals]);

    useEffect(() => {
        if (goalId !== null) {
            
            dispatch(showLoading());
            getWeightById(market, brand, goalId)
                .then((response) => {
                    const goalData = response.data;
                    if (goalData) {
                        setId(goalData?.goalId);
                        setGoalType(goalData?.goalType);
                        setGoalName(goalData?.goalName);
                        setWeight(goalData.weight.toString());
                        //setProduct(goalData.productId);
                        setCreatedAt(goalData.createdAt);
                        setUpdatedAt(goalData.updatedAt);
                    }
                })
                .catch((error) => {
                    dispatch(
                        notifyError('Error!', 'Unable to load goal data.')
                    );
                })
                .finally(() => dispatch(hideLoading()));
        }
    }, [goalId, market]);

    useEffect(() => {
        getWeight(market, brand)
            .then((response) => {
                setExistingGoals(response.data || []);
            })
                .catch(() => {
                    setExistingGoals([]);
                });
        }, [market, brand]);

    const handleWeightChange = (e) => {
        const value = e.target.value;

        // Prevent invalid characters (e, E, +, -, except for decimal point and numbers)
        if (e.nativeEvent.inputType === 'insertText') {
            const char = e.nativeEvent.data;
            if (char && !/[0-9.]/.test(char)) {
                setWeightInputBlocked(true);
                setTouched((prev) => ({ ...prev, weight: true }));
                return; // Block the input
            }
        }

       
        setWeightInputBlocked(false);

        // Allow empty value
        if (value === '') {
            setWeight(value);
            setTouched((prev) => ({ ...prev, weight: true }));
            return;
        }

        
        const numValue = parseFloat(value);
        const normalizedValue =  numValue.toString();

        if (
            C.REGEX_GOAL_WEIGHT.test(normalizedValue) &&
            !isNaN(numValue) &&
            numValue >= 0 &&
            numValue <= 1
        ) {
            setWeight(normalizedValue);
        }

        setTouched((prev) => ({ ...prev, weight: true }));
    };

    const handleGoalNameChange = (e) => {
        const value = e.target.value;
        if (value.length <= 200) {
            const capitalizedValue = value.charAt(0).toUpperCase() + value.slice(1);
            setGoalName(capitalizedValue);
        }
        setTouched((prev) => ({ ...prev, goalName: true }));
    };

    const handleGoalTypeChange = (e) => {
        setGoalType(e.target.value);
        setTouched((prev) => ({ ...prev, goalType: true }));
    };

    // const handleProductChange = (e) => {
    //     setProduct(String(e.target.value));
    //     setTouched((prev) => ({ ...prev, product: true }));
    // };

    // const saveGoal = () => {
    //     const goalData = {
    //         goalType: goalType,
    //         weight: parseFloat(weight),
    //         productId: product,
    //         goalName: goalName,
    //         goalStatus: "ACTIVE",
    //     };

    //     if (goalId !== null) {
    //         // Update goal
    //         dispatch(showLoading());
    //         updateGoal(market, brand, goalId, goalData)
    //             .then(() => {
    //                 onClose();
    //                 dispatch(notify('Saved!', 'Your goal has been saved.'));
    //             })
    //             .catch((error) => {
    //                 dispatch(notifyError('Error!', 'Unable to save goal.'));
    //             })
    //             .finally(() => dispatch(hideLoading()));
    //     } else {
    //         // Create goal
    //         console.log("brand", brand);
    //         dispatch(showLoading());
    //         createGoal(market, brand, goalData)
    //             .then(() => {
    //                 onClose();
    //                 dispatch(
    //                     notifySuccess('Created!', 'New goal has been created.')
    //                 );
    //             })
    //             .catch((error) => {
    //                 dispatch(notifyError('Error!', 'Unable to create goal.'));
    //             })
    //             .finally(() => dispatch(hideLoading()));
    //     }
    // };

    const publishGoal = () => {
        const goalData = {
            goalType: goalType,
            weight: parseFloat(weight),
            //brandFamily: product,
            goalName: goalName,
            goalStatus: 'ACTIVE',
        };

        if (goalId !== null) {
            
            dispatch(showLoading());
            updateGoal(market, brand, goalId, goalData)
                .then(() => {
                    onClose();
                    dispatch(
                        notifySuccess(
                            'Activated!',
                            'The goal has been successfully Saved.'
                        )
                    );
                })
                .catch((error) => {
                    dispatch(notifyError('Error!', 'Unable to save goal.'));
                })
                .finally(() => dispatch(hideLoading()));
        } else {
            
            dispatch(showLoading());
            createGoal(market, brand, goalData)
                .then(() => {
                    onClose();
                    dispatch(
                        notifySuccess(
                            'Activated!',
                            'The goal has been successfully created and activated.'
                        )
                    );
                })
                .catch((error) => {
                    dispatch(
                        notifyError(
                            'Error!',
                            'Unable to create and activate goal.'
                        )
                    );
                })
                .finally(() => dispatch(hideLoading()));
        }
    };

    // COMMENTED OUT: Delete functionality removed as per requirements
    // const removeGoal = () => {
    //     dispatch(showLoading());
    //     deleteGoal(market, goalId)
    //         .then(() => {
    //             onClose();
    //             dispatch(
    //                 notify('Deleted!', 'Goal has been successfully deleted.')
    //             );
    //         })
    //         .catch((error) => {
    //             dispatch(notifyError('Error!', 'Unable to delete goal.'));
    //         })
    //         .finally(() => dispatch(hideLoading()));
    // };

    const closeConfirmDialog = () => {
        setConfirmDialog({ ...confirmDialog, display: false });
    };

    // Fixed: Added safe navigation to prevent runtime errors
    // const getSelectedProduct = (product) => {
    //     const val = product ? product : 'Select product family';
    //     return val || 'Select product family';
    // };

    return (
        <div
            className={`create-rule-container ${
                origin === C.GOAL_EDITOR_MANAGE_PROGRAM &&
                'manage-rule-container'
            }`}
        >
            <style>
                {`.required-asterisk { color: red; }
                  .dropdown-placeholder { color: rgba(0, 0, 0, 0.6) !important; font-style: normal; }
                  .error-text { color: #d32f2f; }`}
            </style>

            <div className="create-rule">
                <div className="create-rule-header">
                    <div className="create-rule-close">
                        <button
                            className="create-rule-close-btn"
                            onClick={onClose}
                        >
                            <ArrowBackIcon />
                            {origin === C.GOAL_EDITOR_CREATE_PROGRAM
                                ? ' Back to Goals'
                                : 'Back to Manage Goals'}
                        </button>
                    </div>
                    <div className="create-rule-title">
                        {origin === C.GOAL_EDITOR_CREATE_PROGRAM ? (
                            <>
                                <h3>Create New Goal</h3>
                                <p>
                                    <span className="required-asterisk">*</span>{' '}
                                    All fields are mandatory
                                </p>
                            </>
                        ) : goalId !== null ? (
                            <h3>Edit Goal</h3>
                        ) : (
                            <h3>Add Goal</h3>
                        )}
                    </div>
                </div>

                <fieldset className="dynamicRuleEditor">
                    <legend className="customLegend">Goal Configuration</legend>

                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 2,
                            p: 2,
                        }}
                    >
                        <div>
                            <label
                                style={{
                                    display: 'block',
                                    marginBottom: '8px',
                                    fontWeight: 'bold',
                                }}
                            >
                                Goal Type{' '}
                                <span className="required-asterisk">*</span>
                            </label>
                            <FormControl
                                fullWidth
                                required
                                className="entity-attribute-dropdown"
                                error={!!validationErrors.goalType}
                            >
                                <Select
                                    value={goalType}
                                    onChange={handleGoalTypeChange}
                                    disabled={C.GOAL_INPUT_DISABLED.includes(
                                        type
                                    )}
                                    className="entity-select"
                                    displayEmpty
                                    renderValue={(selected) => {
                                        if (!selected) {
                                            return (
                                                <span className="dropdown-placeholder">
                                                    Select goal type
                                                </span>
                                            );
                                        }
                                        return selected;
                                    }}
                                >
                                    <MenuItem disabled value="">
                                        <em>Select goal type</em>
                                    </MenuItem>
                                    {goalTypeOptions.map((option) => (
                                        <MenuItem
                                            key={option}
                                            value={option}
                                            className="entity-option"
                                        >
                                            {option}
                                        </MenuItem>
                                    ))}
                                </Select>
                                {validationErrors.goalType && (
                                    <FormHelperText className="error-text">
                                        {validationErrors.goalType}
                                    </FormHelperText>
                                )}
                            </FormControl>
                        </div>

                        <div>
                            <label
                                style={{
                                    display: 'block',
                                    marginBottom: '8px',
                                    fontWeight: 'bold',
                                }}
                            >
                                Goal Name{' '}
                                <span className="required-asterisk">*</span>
                            </label>
                            <TextField
                                value={goalName}
                                onChange={handleGoalNameChange}
                                required
                                fullWidth
                                disabled={C.GOAL_INPUT_DISABLED.includes(type)}
                                placeholder="Enter goal name (e.g., Customer Retention Goal)"
                                helperText={
                                    validationErrors.goalName
                                        ? validationErrors.goalName 
                                        : ''
                                        
                                }
                                error={!!validationErrors.goalName}
                                inputProps={{ maxLength: 200 }}
                            />
                        </div>

                        <div>
                            <label
                                style={{
                                    display: 'block',
                                    marginBottom: '8px',
                                    fontWeight: 'bold',
                                }}
                            >
                                Weight{' '}
                                <span className="required-asterisk">*</span>
                            </label>
                            <TextField
                                type="number"
                                value={weight}
                                onChange={handleWeightChange}
                                onKeyDown={(e) => {
                                    // Prevent e, E, +, - keys
                                    if (['e', 'E', '+', '-'].includes(e.key)) {
                                        e.preventDefault();
                                    }
                                }}
                                required
                                fullWidth
                                placeholder="Enter 0, 1, or decimals like 0.5, .75"
                                inputProps={{ min: 0, max: 1, step: 0.001 }}
                                helperText={
                                    validationErrors.weight
                                        ? validationErrors.weight
                                        : ''
                                }
                                error={!!validationErrors.weight}
                                disabled={C.GOAL_INPUT_DISABLED.includes(type)}
                            />
                           
                            <div
                                style={{
                                    fontSize: '14px',
                                    color: '#666',
                                    marginTop: validationErrors.weight ? '4px' : '2px',
                                    fontStyle: 'italic',
                                }}
                            >
                                Tip: "Proportion of actions for this goal from the model"
                            </div>
                            
                        </div>

                        {/* <div>
                            <label
                                style={{
                                    display: 'block',
                                    marginBottom: '8px',
                                    fontWeight: 'bold',
                                }}
                            >
                                Product Family{' '}
                                <span className="required-asterisk">*</span>
                            </label>
                            <FormControl
                                fullWidth
                                required
                                className="entity-attribute-dropdown"
                                error={!!validationErrors.product}
                            >
                                <Select
                                    value={getSelectedProduct(product)}
                                    onChange={handleProductChange}
                                    disabled={C.GOAL_INPUT_DISABLED.includes(
                                        type
                                    )}
                                    className="entity-select"
                                    displayEmpty
                                    renderValue={(selected) => {
                                        return getSelectedProduct(product);
                                    }}
                                >
                                    <MenuItem disabled value="">
                                        <em>Select product family</em>
                                    </MenuItem>
                                    {productOptions.map((option) => (
                                        <MenuItem
                                            key={option}
                                            value={option}
                                            className="entity-option"
                                        >
                                            {option}
                                        </MenuItem>
                                    ))}
                                </Select>
                                {validationErrors.product && (
                                    <FormHelperText className="error-text">
                                        {validationErrors.product}
                                    </FormHelperText>
                                )}
                            </FormControl>
                        </div> */}
                    </Box>
                </fieldset>

                <div className="create-rule-cta-container">
                    <>
                        <button
                            className={`publish-rule ${
                                saveEnabled ? 'active' : 'inactive'
                            }`}
                            
                            onClick={() => {
                                if (saveEnabled) {
                                    setConfirmDialog({
                                        display: true,
                                        title: 'Confirm: Save Goal!',
                                        note: 'Once you save this goal it will become active.',
                                        onConfirm: publishGoal,
                                        onClose: closeConfirmDialog,
                                        confirmText: 'Yes, Save Goal',
                                        backText: 'No, Continue Editing',
                                    });
                                }
                            }}
                        >
                            Save Goal
                        </button>
                    </>
                </div>
            </div>
            {confirmDialog.display && (
                <ConfirmDialog
                    title={confirmDialog.title}
                    message={confirmDialog.message}
                    note={confirmDialog.note}
                    onClose={confirmDialog.onClose}
                    onConfirm={confirmDialog.onConfirm}
                    confirmText={confirmDialog.confirmText}
                    backText={confirmDialog.backText}
                />
            )}
        </div>
    );
};

export default GoalEditor;
